import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Label, Table, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import get from 'lodash/get'

class UserRow extends Component {
  state = {
    removing: false,
  }

  removeUser = key => {
    const confirmation = window.confirm('Are you sure to delete?')

    if (confirmation === true) {
      this.setState({ removing: true })

      firebase
        .firestore()
        .collection('dashboard_users')
        .doc(key)
        .delete()
        .then(() => this.setState({ removing: false }))
    }
  }

  renderOnlineLabel = () => {
    const { data } = this.props

    return (
      <Label color={data.online ? 'green' : 'red'} style={{ width: 120 }}>
        {data.online ? 'Online' : 'Offline'}
      </Label>
    )
  }

  renderRoleLabel = () => {
    const { data, roles } = this.props
    const { role } = data
    const roleName = (roles[role] && roles[role].name) || '...'

    return <Label style={{ width: 120 }}>{roleName}</Label>
  }

  renderMerchantTagNames = () => {
    const {
      restaurants,
      data: { manageMerchantIds },
    } = this.props

    if (!manageMerchantIds) return null

    return manageMerchantIds.map((merchantId, index) => {
      const merchantName = get(restaurants, `${merchantId}.name`, 'N/A')

      return (
        // eslint-disable-next-line react/no-array-index-key
        <Label key={`${index}-${merchantId}`} style={{ marginBottom: 5 }}>
          {' '}
          {merchantName}{' '}
        </Label>
      )
    })
  }

  render() {
    const { removing } = this.state
    const { noIndex, data, userKey, onEdit } = this.props
    const { username, email, role, region } = data

    return (
      <Table.Row>
        <Table.Cell>{noIndex}</Table.Cell>
        <Table.Cell>{username}</Table.Cell>
        <Table.Cell textAlign="center">{email}</Table.Cell>
        <Table.Cell textAlign="center" style={{ textTransform: 'uppercase' }}>
          {region}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {role === 'operator@role' ? this.renderOnlineLabel() : this.renderRoleLabel()}
        </Table.Cell>
        {role === 'merchant_admin@role' && (
          <Table.Cell textAlign="center">{this.renderMerchantTagNames()}</Table.Cell>
        )}
        <Table.Cell textAlign="center" style={{ minWidth: 170 }}>
          <Button size="tiny" onClick={onEdit}>
            Edit
          </Button>
          <Button size="tiny" color="red" loading={removing} onClick={() => this.removeUser(userKey)}>
            Delete
          </Button>
        </Table.Cell>
      </Table.Row>
    )
  }
}

const mapStateToProps = ({ rolePermission, restaurants }) => ({
  roles: rolePermission.roles,
  restaurants: restaurants.data,
})

export default connect(
  mapStateToProps,
  null
)(UserRow)



// WEBPACK FOOTER //
// ./src/containers/users/row.js